export default "__VITE_ASSET__DmKl3gkq__"